import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {first} from 'rxjs/operators';
import {BankAccountService} from '../../services/bank-account.service';

declare var swal: any;

@Component({
    selector: 'app-bank-accounts',
    templateUrl: './bank-accounts.component.html',
    styleUrls: ['./bank-accounts.component.scss']
})
export class BankAccountsComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    bankAccounts: any[];
    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private bankAccountService: BankAccountService
    ) {
    }

    ngOnInit() {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.bankAccountService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.bankAccounts = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'bank_name'},
                {data: 'bank_account_number'},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(bankAccount: any): void {
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.bankAccountService.delete(bankAccount.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    }, error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }
}
